import { useBranding } from "@/context/BrandingContext";
import { API_BASE } from "@/lib/api";

export function BrandMark({ tagline = true, collapsed = false, light = false }) {
  const branding = useBranding();
  const nameColor = light ? "text-white" : "text-[#C8202E]";
  const taglineColor = light ? "text-white/80" : "text-foreground/70";
  return (
    <div className="inline-flex items-center gap-2.5" data-testid="brand-mark">
      <img
        src={branding.has_logo ? `${API_BASE}/public/branding/logo` : "/brand/bnb-logo.png"}
        alt={branding.display_name}
        className="h-10 w-14 shrink-0 object-contain"
      />
      {!collapsed && (
        <div>
          <div className={`font-logo text-xl font-extrabold leading-none tracking-tight ${nameColor}`}>
            {branding.display_name}
          </div>
          {tagline && (
            <div className={`mt-1 text-[8.5px] font-semibold uppercase tracking-[0.16em] ${taglineColor}`}>
              {branding.tagline}
            </div>
          )}
        </div>
      )}
    </div>
  );
}


